module.exports = __webpack_public_path__ + "img/pzjk.f7cda45e.png";